// extracted by mini-css-extract-plugin
export default {"submit-feedback-modal":"submit-feedback_submit-feedback-modal__CUxq-","submit-feedback-modal__body":"submit-feedback_submit-feedback-modal__body__O6zza"};